module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-mitsu.e08c19a0.jpg";